import { Box, Grid, Typography } from '@mui/material';
import { KeyValue } from './contributor';
import { SubHeading } from '../investors/components';
import React, { useEffect, useState } from 'react';
import { Gridstyles } from './index';
import { Applicant, Broker, BrokerList, DPNameType } from '../../redux-store/types/api-types';
// eslint-disable-next-line
import { DLCLMasters, LAW_TYPES } from '../../utils/constant';
import {
  currencyConversion,
  getclIdField,
  getdpIdField,
  isCDSL,
  nameOfBrokerExists,
} from '../../utils/utilityFunctions';
import { styles } from '../../Styles/styles';
import { useMdmsBrokerListData } from '../../utils/useDataMdms';
import { formatShortDate } from '../../utils/date';
import { getDPNameList } from '../../redux-store/actions/userManagement';
import { useDispatch } from 'react-redux';
import { useDPNameListData } from '../../utils/useDPNameList';

export default function KycDetails({
  applicants = [],
}: {
  applicants: Partial<Applicant>[];
}): JSX.Element {
  // const [brokerList, setBrokerList] = useState<BrokerList>();
  // const { BrokerList } = useMdmsBrokerListData();
  // const dispatch = useDispatch();
  // const [dpbrokerList, dpsetBrokerList] = useState<DPNameType[]>([]);
  // useEffect(() => {
  //   (async function () {
  //     try {
  //       setBrokerList(BrokerList as BrokerList);
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  // }, [BrokerList]);

  // useEffect(() => {
  //   const fetchBrokerList = async () => {
  //     try {
  //       const response = (await dispatch(getDPNameList())) as unknown as DPNameType[];
  //       dpsetBrokerList(response);
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   };

  //   fetchBrokerList();
  // }, []);

  // Broker/DP name list is served from redux (fetched once, cached).
  const dpbrokerList = useDPNameListData();

  return (
    <>
      <Box sx={styles.ApplicationDetailsCommonLayout} mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
              Additional KYC Details
            </Typography>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading sx={{ letterSpacing: 0.5 + 'px' }}>{title}</SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={15}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue
                        title={'Occupation Details'}
                        description={applicant.occupationDetails}
                      />
                      <KeyValue
                        title={'Gross Annual Income'}
                        description={applicant.grossAnnualIncome}
                      />
                      <KeyValue
                        title={'Net-Worth'}
                        description={applicant.netWorth}
                        amount={currencyConversion(applicant.netWorth)}
                      />
                      <KeyValue
                        title={'Net Worth Date'}
                        description={formatShortDate(applicant.netWorthDate)}
                      />
                      <KeyValue
                        title={'Politically Exposed Person (PEP) Status'}
                        description={applicant.politicallyExposedPersonStatus}
                      />
                      <KeyValue title={'CKYC Number'} description={applicant.ckycNo} />
                      <KeyValue
                        title={'Demat Account Details (for allotment of units)'}
                        description={DLCLMasters[applicant.dlclId || '']}
                      />
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={isCDSL(applicant.dlclId || '') ? 'DPCL ID' : 'DP ID'}
                          description={applicant.dpId}
                        />
                      )}
                      {getclIdField(applicant.dlclId || '') && (
                        <KeyValue title={'CL ID'} description={applicant.clId} />
                      )}
                      {/* {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={'Name of Broker/Depository Participant (DP)'}
                          description={
                            nameOfBrokerExists(
                              brokerList?.broker_list as Broker[],
                              applicant.nameOfBroker || ''
                            )
                              ? brokerList?.broker_list.find(
                                  (broker) => broker.key === applicant.nameOfBroker
                                )?.value
                              : applicant.nameOfBroker
                          }
                        />
                      )} */}
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title="Name of Broker/Depository Participant (DP)"
                          description={
                            dpbrokerList.find(
                              (broker: DPNameType) =>
                                Number(broker.id) === Number(applicant.broker_id)
                            )?.brokerName || 'N/A'
                          }
                        />
                      )}
                      {applicant.lawType && (
                        <KeyValue
                          title={'Law Under Which Formed/Incorporated'}
                          description={LAW_TYPES[applicant.lawType]}
                        />
                      )}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
